import type { ContentObjectList, NonEventContentObjectDetail } from 'models';
import { canSeeContentObjectLikes } from 'permissions';
import { LikeCount } from '../../../like-count';
import { CommentCount } from '../comment-count';
import { StatusBarLayout } from '../status-bar-layout';

type P = {
  item: ContentObjectList | NonEventContentObjectDetail;
  onShowComments?: () => void;
};

const BasicStatusBar = ({ item, onShowComments }: P) => {
  const { commentsCount, liked: isLiked, likesCount } = item;
  const isLikeCountVisible = likesCount > 0 && canSeeContentObjectLikes({ contentObject: item });
  const isCommentsVisible = commentsCount > 0;

  return Boolean(isLikeCountVisible) || isCommentsVisible ? (
    <StatusBarLayout
      left={
        <div className="basic-status-bar">
          {isLikeCountVisible ? <LikeCount count={likesCount} liked={isLiked} /> : null}
          {/* TODO this will probably not be clickable in bookmarks */}
          {isCommentsVisible ? <CommentCount count={commentsCount} onShowComments={onShowComments} /> : null}
        </div>
      }
      right={null}
    />
  ) : null;
};

export default BasicStatusBar;
